import type { RouteSort } from '~/hooks/usePaginatedQuery';

// A column key doubles as the backend sort field, so each set is both the list of clickable
// headers and the whitelist of what a click may send.

// Mirrors SellerVendorGroupSortSql.Field on the backend, minus 'stock' (no column in this view).
export const VENDOR_GROUP_SORTABLE_KEYS: ReadonlySet<string> = new Set([
  'seller',
  'length',
  'price',
  'leadTime',
]);

// Mirrors CannedTallyGroupSort.Field on the backend, minus 'length' (no per-row value) and
// 'facility' (no column in tally mode).
export const CANNED_TALLY_SORTABLE_KEYS: ReadonlySet<string> = new Set([
  'seller',
  'price',
  'stock',
  'leadTime',
]);

/**
 * Turns a comparison-table header click into the sort its query sends.
 *
 * @param sortableKeys - The view's sortable column keys.
 * @param column       - The clicked column's key.
 * @param direction    - The header's new direction; `null` once it cycles back to unsorted.
 * @returns The sort to send, or `undefined` to fall back to the server's default order.
 *
 * @example
 * setSort(toComparisonSort(VENDOR_GROUP_SORTABLE_KEYS, 'length', 'asc'));
 */
export function toComparisonSort(
  sortableKeys: ReadonlySet<string>,
  column: string,
  direction: 'asc' | 'desc' | null
): RouteSort | undefined {
  if (!direction || !sortableKeys.has(column)) {
    return undefined;
  }
  return [{ field: column, direction: direction === 'asc' ? 'ASC' : 'DESC' }];
}
